import React, { ReactElement, useEffect, useState } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import './formInputNumber.less';
import NumberFormat from 'react-number-format';
import { Input } from 'antd';
import { MAX_CHARACTERS_LIMIT } from '../../../constants/commonConstants';

export const FormInputNumber = (props: any): (ReactElement | null) => {
  const [extraRules, setExtraRules] = useState<any[]>([]);
  const formConfig = useGetFormConfig(props);
  const {
    label, placeholder, disabled, onChange: onChangeFromOrigin, key, suffixTestId, noOfDecimalAllowed,
    allowClear, onFocus, onBlur,
    maxLengthValue, fieldLengthValue, isMaxLengthNotApplicable, maxLength = false, isMemberAge,
  } = formConfig;

  useEffect((): void => {
    if (disabled) {
      setExtraRules([]);
    }
  }, [disabled]);

  const onChange = (event: any, labelConfig: any): any => {
    if (onChangeFromOrigin) {
      onChangeFromOrigin(event, labelConfig);
    }
    if (isMemberAge) {
      setExtraRules([
        {
          max: maxLengthValue ? fieldLengthValue?.[0] : !isMaxLengthNotApplicable ? (maxLength || MAX_CHARACTERS_LIMIT) : undefined,
        },
      ]);
    }
  };

  return <FormItem formConfig={formConfig} extraRules={extraRules} >
    <NumberFormat
      data-testid={`${key}${suffixTestId || ''}`}
      customInput={Input}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      onChange={(event: any): void => onChange(event, label)}
      decimalScale={noOfDecimalAllowed}
      allowClear={allowClear}
      onBlur={(): void => onBlur && onBlur()}
      onFocus={(): void => onFocus && onFocus()}
      />
  </FormItem>;
};

export default FormInputNumber;
